const removeFirstSlash = (str: string) => {
  if (str.substring(0, 1) === '/') {
    return str.substring(1);
  }
  return str;
};

const upperFirst = (str: string) => {
  return [str.substring(0, 1).toUpperCase(), str.substring(1)].join('');
};

const toPGSQLArrayLitteral = (arr: (string | number | undefined | null)[]) => {
  return `{${arr
    .map((item) => {
      if (typeof item === 'undefined') {
        return null;
      }
      if (typeof item === 'string') {
        return `"${item}"`;
      }
      return item;
    })
    .filter((item) => item)
    .join(',')}}`;
};

export default { upperFirst, removeFirstSlash, toPGSQLArrayLitteral };
